import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { getConfig } from "../config";
// import { useNavigate } from 'react-router-dom';



const Auth0ProviderWithHistory= ({ children }) => {
  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
  
// const navigate=useNavigate()

  const onRedirectCallback = (appState) => {
    console.log('App State: ',appState)
    console.log('Location Path name: ',window.location.pathname)
    window.location.replace(
      appState && appState?.returnTo
        ? appState?.returnTo
        : window.location.pathname
    );
 
  };


  const config = getConfig();
  
  const providerConfig = {
    domain: config.domain,
    clientId: config.clientId,
    ...(config.audience ? { audience: config.audience } : null),
    // redirectUri:window.location.origin+window.location.pathname,
    redirectUri:window.location.origin,
    // onRedirectCallback:onRedirectCallback,
    useRefreshTokens:true,
    // cacheLocation:"localstorage",
    // onRedirectCallback,
  };

  return (
    <Auth0Provider {...providerConfig}>
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;




